export const MAX_COUNTER = 99;
export const MAX_BADGE_COUNT = "99+";
export const BADGE_TYPES = ["badge", "counter"];